import { gql } from '@apollo/client';
import { ErrorFragment } from '../fragments';
import { AnalysisMetaFieldsFragment } from '../analysis/fragments';
import { SignificanceQueryFieldsFragment } from './fragments';

export const SIGNIFICANCE_EXECUTE = gql`
  mutation SignificanceExecute($input: SignificanceExecuteInput!) {
    significanceExecute(input: $input) {
      entity {
        ...AnalysisMetaFields
        query {
          ...SignificanceQueryFields
        }
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${AnalysisMetaFieldsFragment}
  ${SignificanceQueryFieldsFragment}
  ${ErrorFragment}
`;
